function inViewport() {
	emergence.init({
		elemCushion: 0.0,
		reset: false,
	});
}